// extracted by mini-css-extract-plugin
module.exports = {"customBtn":"style_customBtn__xXmEi","small":"style_small__gAqx9","medium":"style_medium__SScAf","large":"style_large__atBxZ"};